export var SoundType;
(function (SoundType) {
    SoundType["NOTIFICATION"] = "notification";
    SoundType["BACKGROUND"] = "background";
})(SoundType || (SoundType = {}));
